/* eslint-disable max-lines */
import { exportUsers } from 'actions';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerName } from 'selectors/auth';
import { useSelector } from 'store';

const AllUsersHeaderButtons: React.FC = () => {
  const dispatch = useDispatch();

  const customerName = useSelector(getCustomerName);

  const handleExportUsers = (): void => {
    dispatch(exportUsers({ filename: `${customerName}_AllUsers`, export_type: 'all' }));
  };

  return (
    <>
      <div className="flex flex-row justify-start gap-2">
        <button
          onClick={handleExportUsers}
          type="button"
          className="h-8 button button--secondary focus:outline-none"
          key="export"
        >
          <span className="font-bold whitespace-no-wrap">Download CSV</span>
        </button>
      </div>
    </>
  );
};

export default AllUsersHeaderButtons;
